import React from 'react';

import * as Styled from './Section.styled';
import Header from 'components/header';
import Ferret from 'components/ferret';
import HeroWithFerret from 'components/heroWithFerret';
import Footer from 'components/footer';
import FooterLinkboxes from 'components/footerLinkboxes';
import Heading from 'components/heading';
import Gap from 'components/gap';
import TextUnderImage from 'components/textUnderImage';
import TextNextToImage from 'components/textNextToImage';
import USP from 'components/usp';
import FeaturedTrips from 'components/featuredTrips';
import GetTheApp from 'components/getTheApp';
import MapNextToText from 'components/mapNextToText';
import { SectionProps } from './Section.props';

export const TYPES = {
  header: Header,
  footer: Footer,
  hero: HeroWithFerret,
  ferret: Ferret,
  footerLinkboxes: FooterLinkboxes,
  heading: Heading,
  gap: Gap,
  textUnderImage: TextUnderImage,
  textNextToImage: TextNextToImage,
  mapNextToText: MapNextToText,
  usp: USP,
  featuredTrips: FeaturedTrips,
  getTheApp: GetTheApp,
};

const Section = ({ type, config = {}, theme }: SectionProps) => {
  const Component = TYPES[type];

  return (
    <Styled.Wrapper
      background={type === 'mapNextToText' ? undefined : theme?.backgroundColor}
      data-section-type={type}
    >
      {Component && <Component theme={theme} {...config} />}
    </Styled.Wrapper>
  );
};

export default Section;
